import React, { PureComponent } from 'react';
import Popup from "./Popup";

class ButtonEliminar extends PureComponent {
    constructor(props) {
        super(props);
    }


    render() {
        const { eliminarCobranza, cobranza } = this.props;

        return (<Popup
                    clave={"popup-baja-" + cobranza.Id}
                    titulo="Para solicitar la baja del pago, haga clic en Listo"
                    confirmar={() => this.props.eliminarCobranza(cobranza, 7)}>
                    <a className="clickable none-text-decoration glyphicon glyphicon-trash" data-toggle="dropdown"></a>
                </Popup>);
    }
}

export default ButtonEliminar;